module.exports = __webpack_public_path__ + "img/close-02.ce913688.svg";